/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  CircularProgress,
  TextField,
} from "@mui/material";
import MDBox from "components/MDBox";

// Data
import CoursesList from "layouts/clients/coursesUser/data/coursesList";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import MDButton from "components/MDButton";

// Service
import { subscribe } from "services/subscription/subscriptions.services";
import { get as getCourse } from "services/course/courses.services";
import { get as getLesson } from "services/lesson/lessons.services";
import { getCurrent as getClient } from "services/user/users.services";

const formData = (coursesIdAdd, coursesIdDelete, provenance) => {
  const data = {
    coursesIdAdd,
    coursesIdDelete,
    provenance,
  };
  return data;
};

function ModalAdd({ userId, finished }) {
  const lessons = useSelector((state) => state.lesson.allLessons);
  const courses = useSelector((state) => state.course.allCourses);
  const [coursesId, setCoursesId] = useState([]);
  const [coursesIdAdd, setCoursesIdAdd] = useState([]);
  const [coursesIdDeleted, setCoursesIdDeleted] = useState([]);
  const [provenance, setProvenance] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatchApi = useDispatch();

  useEffect(() => {
    setCoursesId(
      courses.filter((c) => c.subscriptions.some((s) => s.client.id === userId)).map((cf) => cf.id)
    );
  }, [courses]);

  const handleChecked = (e, id) => {
    e.preventDefault();
    const { checked } = e.target;
    if (checked) {
      setCoursesId((c) => c.concat([id]));
      if (!coursesIdDeleted.includes(id)) setCoursesIdAdd((c) => c.concat([id]));
      setCoursesIdDeleted((c) => c.filter((lessonId) => lessonId !== id));
    } else {
      setCoursesId((c) => c.filter((courseId) => courseId !== id));
      if (!coursesIdAdd.includes(id)) setCoursesIdDeleted((c) => c.concat([id]));
      setCoursesIdAdd((c) => c.filter((lessonId) => lessonId !== id));
    }
  };

  const handleAdd = async (e) => {
    const passed = true;
    e.preventDefault();

    setLoading(true);

    subscribe(
      userId,
      formData(coursesIdAdd, coursesIdDeleted, provenance === "" ? null : provenance)
    )
      .then(async () => {
        for (const id of coursesIdAdd.concat(coursesIdDeleted)) {
          try {
            await getCourse(id).then(({ data }) => {
              dispatchApi({ type: "UPDATED_COURSE", data });
            });
            await getClient(id).then(({ data }) => {
              dispatchApi({ type: "UPDATED_USER", data });
            });
            lessons
              .filter((l) => l.course.id === id)
              .forEach((lf) => {
                getLesson(lf.id).then(({ data }) => {
                  dispatchApi({ type: "UPDATED_LESSON", data });
                });
              });
          } catch (error) {
            console.log(error);
          }
        }
      })
      .catch()
      .finally(() => {
        setLoading(false);
        if (passed) finished();
      });
  };

  return (
    <Dialog fullWidth maxWidth="lg" open>
      <DialogTitle>Ajouter cours</DialogTitle>
      <DialogContent>
        <MDBox pt={3} sx={{ overflowX: "hidden" }}>
          <CoursesList listId={coursesId} handleChecked={handleChecked} />
        </MDBox>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "space-between" }}>
        <div>
          <TextField
            disabled={coursesIdAdd.length === 0}
            value={provenance}
            sx={{ ml: 1, my: 1, minWidth: 140 }}
            onChange={(e) => setProvenance(e.target.value)}
            label="Provenance"
            id="outlined-size-small"
          />
        </div>
        <div>
          <MDButton onClick={finished} disabled={loading} variant="text" color="info" size="small">
            Retour
          </MDButton>
          <MDButton onClick={handleAdd} disabled={loading} variant="text" color="info" size="small">
            Valider
            {loading && (
              <CircularProgress size="1.5em" color="info" sx={{ position: "absolute" }} />
            )}
          </MDButton>
        </div>
      </DialogActions>
    </Dialog>
  );
}

ModalAdd.propTypes = {
  userId: PropTypes.number.isRequired,
  finished: PropTypes.func.isRequired,
};

export default ModalAdd;
